import TextOption from '@activities/items/ItemActivity/components/TextOption';
import Column from '@components/Column';
import { OptionGroup } from '@models/item';

import styles from './styles.module.scss';

interface Props {
    optionGroups: OptionGroup[];
    itemId: string;
}

function ExpandedPersonalOptions({ optionGroups, itemId }:Props) {
  return (
        <Column as='section'
                className={styles.container}
                fullWidth >
            {optionGroups.map((optionGroup, idx) => (
                <TextOption optionGroup={optionGroup}
                            noDivider={idx === 0}
                            key={optionGroup.optionGroupId}
                            itemId={itemId} />
            ))}
        </Column>
  );
}

export default ExpandedPersonalOptions;
